const BORDER = '#e5e7f6';
const BLUE = '#304fff';
const ERROR = '#c62828';

/** Xtram input box (AddJournalEntryModal `styleInput` look) for `variant="standard"` TextFields. */
export const xtramInputSx = (hasError = false) => ({
    height: 'var(--xtram-control-height, 40px)',
    minHeight: 'var(--xtram-control-height, 40px)',
    padding: '0 10px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    background: '#fff',
    border: `2px solid ${hasError ? ERROR : BORDER}`,
    fontFamily: 'var(--xtram-font)',
    fontSize: 'var(--xtram-text-sm, 13px)',
    fontWeight: 500,
    color: '#1d2452',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': { borderColor: hasError ? ERROR : BLUE },
    '&:focus-within': {
        borderColor: hasError ? ERROR : BLUE,
        boxShadow: `0 0 0 2px ${hasError ? 'rgba(198, 40, 40, 0.12)' : 'rgba(48, 79, 255, 0.1)'}`,
    },
    '&.Mui-disabled': { background: '#f5f6fd', borderColor: BORDER },
});

export const xtramInputProps = (direction, hasError = false) => ({
    disableUnderline: true,
    className: `custom-box-sizing-border-box ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
    sx: xtramInputSx(hasError),
});

export const xtramTextAlign = (direction) => ({
    style: {
        textAlign: direction === 'rtl' ? 'right' : 'left',
        direction,
    },
});

/** `inputSx` for CustomDatePicker / CustomMonthDatePicker so dates match the text inputs. */
export const xtramDateInputSx = (hasError = false) => ({
    background: '#fff',
    border: `2px solid ${hasError ? ERROR : BORDER}`,
    boxSizing: 'border-box',
    '&:hover': { borderColor: hasError ? ERROR : BLUE },
    '&:focus-within': { borderColor: hasError ? ERROR : BLUE },
    '&.Mui-disabled': { background: '#f5f6fd' },
});

export const xtramPopperSx = {
    '& .MuiPaper-root': {
        borderRadius: '10px',
        border: `1px solid ${BORDER}`,
        boxShadow: '0 8px 24px rgba(26, 31, 73, 0.14)',
    },
    '& .MuiAutocomplete-listbox': { padding: '6px' },
    '& .MuiAutocomplete-option': {
        borderRadius: '6px',
        fontFamily: 'var(--xtram-font)',
        fontSize: 'var(--xtram-text-sm, 13px)',
        '&[aria-selected="true"], &.Mui-focused, &:hover': {
            background: 'rgba(48, 79, 255, 0.08) !important',
            color: BLUE,
        },
    },
};
